<template>
  <ContainerBasic
    v-if="pageData.typeHandle === PageTypeHandle.EVENT"
    container-type="CONTENT"
    class="flex flex-col px-md md:px-0"
  >
    <HeadlineDynamic
      :headline="pageData?.title ?? ''"
      :has-decoration="true"
      align-text="center"
      level="h1"
      class="mb-sm md:mb-md"
    />

    <div
      class="flex flex-row justify-center mx-auto mt-0 mb-sm md:mb-md place-items-center gap-xs"
    >
      <EventCourseIndicator
        :course-type="event.courseType"
        :is-clickable="false"
      ></EventCourseIndicator>
      <EventCmeIndicator v-if="event.cmePoints" :cme-points="event.cmePoints" />
    </div>
    <div
      class="flex flex-row flex-wrap items-stretch justify-center place-content-start gap-y-xs md:gap-y-0"
    >
      <div
        class="flex flex-row flex-wrap text-center w-full md:w-[40%] md:text-right"
      >
        <div v-if="event.date" class="w-full">
          {{ getWeekdayLocale(event.date, lang).slice(0, 2) }}.
          <span class="text-xl">
            <b> {{ dayjs(event.date).format('D') }}. </b>
          </span>
          {{ getMonthLocale(event.date, lang) }}
          {{ dayjs(event.date).format('YYYY') }}
          &middot;
          {{ getHoursLocale(event.startTime, lang, false) }}
          -
          {{ getHoursLocale(event.endTime, lang, true) }}
        </div>
        <div v-else class="w-full">
          <span class="w-full text-center md:text-left">{{
            t('event.individualAppointment')
          }}</span>
        </div>
        <div
          v-for="(date, index) in event.additionalDates"
          :key="index"
          class="w-full"
        >
          {{ getWeekdayLocale(date.date, lang).slice(0, 2) }}.
          <span class="text-xl">
            <b> {{ dayjs(date.date).format('D') }}. </b>
          </span>
          {{ getMonthLocale(date.date, lang) }}
          {{ dayjs(date.date).format('YYYY') }}
          &middot;
          {{ getHoursLocale(date.startTime, lang, false) }}
          -
          {{ getHoursLocale(date.endTime, lang, true) }}
        </div>
      </div>
      <div class="hidden px-xl py-2xs md:flex">
        <div class="bg-gray-300 px-[1px] h-full my-auto"></div>
      </div>
      <div class="self-center text-center md:text-left w-full md:w-[40%]">
        <div
          v-if="event.location?.street"
          class="w-full text-center md:text-left"
        >
          {{ event.location.street }}
          {{ event.location.streetNumber ?? '' }}
        </div>
        <div v-if="event.location" class="w-full text-center md:text-left">
          {{ event.location.zipCode ?? '' }}
          {{ event.location.title }}
        </div>
        <div
          v-if="event.courseType === ECourseType.HYBRID"
          class="w-full text-center md:text-left"
        >
          {{ t('event.onlineLocationAddition') }}
        </div>
      </div>
      <div class="flex flex-row flex-wrap justify-center w-full mt-0 md:mt-md">
        <p><b>Zielgruppe:&nbsp;</b></p>
        <p
          v-for="(targetGroup, index) in event.targetGroup"
          :key="index"
          class="text-center"
          v-text="
            index < event.targetGroup.length - 1
              ? `${t('targetGroups.events.' + targetGroup)},&nbsp;`
              : t('targetGroups.events.' + targetGroup)
          "
        />
      </div>
    </div>
  </ContainerBasic>
</template>

<script setup lang="ts">
import dayjs, {
  getWeekdayLocale,
  getMonthLocale,
  getHoursLocale,
} from '@/helpers/dayJs';
import { PageTypeHandle } from '@/@types/type-handle';
import { ECourseType } from '@/@types/course-type';
import EventCourseIndicator from '@/components/event/event-course-indicator.vue';
import EventCmeIndicator from '@/components/event/event-cme-indicator.vue';
import ContainerBasic from '@/components/components/container-basic.vue';
import type { EventPage } from '~~/src/server/transformers/page/eventPage';
import HeadlineDynamic from '@/components/components/core/headline-dynamic/vdv/headline-dynamic.vue';
import type { EventIntroductionData } from './blockType';

const { t } = useTrans();

defineProps({
  blockData: {
    type: Object as PropType<EventIntroductionData>,
    required: true,
    default: {} as EventIntroductionData,
  },
});
//TODO Date localizations with global variable from store/l18n?
const lang = 'de';

const pageData = usePageData<EventPage>();
const event = pageData.value.event;
</script>
